import styled from 'styled-components';

export const Wrapper = styled.div`
  margin-bottom: 16px;
`;

export const IconMail = styled.i`
  position: absolute;
  left: 13px;
  top: 11px;
`;
